export const MIN_LOADING_MS = 600;

export async function waitForMinimumDelay(
  startedAt: number,
  minimumMs = MIN_LOADING_MS,
): Promise<void> {
  const elapsedMs = Date.now() - startedAt;
  if (elapsedMs >= minimumMs) return;

  await new Promise<void>((resolve) => {
    window.setTimeout(resolve, minimumMs - elapsedMs);
  });
}
